import { PaginatedTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { GlobalAudiosNoMatchesReport } from '../types';

export function GlobalAudiosNoMatchesReportResult(
  p: ReportResultProps<GlobalAudiosNoMatchesReport>,
) {
  const { $t } = useIntl();

  return (
    <PaginatedTable
      columns={[
        {
          Header: $t({
            id: 'audit.props.customId',
            defaultMessage: 'Custom ID',
          }),
          accessor: (item) => item.audio.customId,
          w: 15,
        },
        {
          Header: $t({
            id: 'common.entities.group',
            defaultMessage: 'grupo',
          }),
          accessor: (item) => item.audio.stationsGroup?.name,
          w: 20,
        },
        {
          Header: $t({
            id: 'common.station',
            defaultMessage: 'Emisora',
          }),
          accessor: (item) => item.audio.station?.name,
          w: 20,
        },
        {
          Header: $t({
            id: 'common.createdAt',
            defaultMessage: 'Creado',
          }),
          accessor: (item) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={item.audio.createdAt} day="2-digit" month="2-digit" year="2-digit" />
              &nbsp;&nbsp;
              <LTime value={item.audio.createdAt} />
            </div>
          ),
          w: 20,
        },
        {
          Header: $t({
            id: 'common.updatedAt',
            defaultMessage: 'Actualizado el',
          }),
          accessor: (item) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={item.audio.updatedAt} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={item.audio.updatedAt} />
            </div>
          ),
          w: 20,
        },
      ]}
      data={p.result.items}
    />
  );
}
